import { useMemo } from 'react';
import { colorToVariable } from '../componentsThemeMap.js';
import { useInView } from '../hooks/useInView.js';
import { AnalyticsProvider } from '../providers/AnalyticsProvider.js';
import '../ui/Div/index.js';
import { ErrorBoundary } from '../ui/ErrorBoundary.js';
import { Text } from '../ui/Text.js';
import { scrollToAnchor } from '../utils/scrollToAnchor.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Div } from '../ui/Div/Div.js';
function EditorialArticleNavigationList({
  quickScrollContent,
  height = 300
}) {
  const anchors = useMemo(() => quickScrollContent?.map(q => q.anchor), [quickScrollContent]);
  const anchorIndexInView = useInView(anchors);
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "EditorialArticleNavigationList",
      children: /*#__PURE__*/jsx(Div, {
        as: "ul",
        display: "block",
        spacingStart: 6,
        overflowY: "auto",
        height: "100%",
        maxHeight: `calc(100vh - ${height}px)`,
        children: quickScrollContent?.map(({
          text,
          anchor
        }, index) => {
          return /*#__PURE__*/jsx(Div, {
            as: "li",
            position: "relative",
            children: /*#__PURE__*/jsx(Div, {
              display: "list-item",
              css: {
                background: 'inherit',
                cursor: 'pointer',
                listStyleType: 'none',
                ':hover > p': {
                  color: colorToVariable('primary')
                }
              },
              spacingVertical: 1,
              spacingEnd: 1
              // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
              ,

              onClick: () => scrollToAnchor(anchor, 250),
              children: /*#__PURE__*/jsxs(Fragment, {
                children: [anchorIndexInView === index && /*#__PURE__*/jsx(Div, {
                  position: "absolute",
                  height: "100%",
                  width: "2px",
                  left: -16,
                  top: 0,
                  background: "primary"
                }), /*#__PURE__*/jsx(Text, {
                  variant: "label2",
                  as: "p",
                  color: anchorIndexInView === index ? 'primary' : 'foreground',
                  children: text
                })]
              })
            })
          }, index);
        })
      })
    })
  });
}
export { EditorialArticleNavigationList };
//# sourceMappingURL=EditorialArticleNavigationList.js.map
